import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ISecQuestions } from '../request-password/request-password.component';
import { BeanUser, IrequestValidateAnswers } from '@pacifico/interfaces/configurations-api.interface';
import { SharedApiService } from '@pacifico/services/api/shared/shared-api.service';
import { IRequestSendEmail } from '@pacifico/interfaces/shared-api.interface';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { IresponseValidateAnswers } from '../../../../commons/models/interfaces/configurations-api.interface';
import { ConfigurationsApiService } from '@pacifico/services/api/configurations/configurations-api.service';
import { AlertService } from '@pacifico/services/local/alert.service';

@Component({
	selector: 'app-validate-data',
	templateUrl: './validate-data.component.html',
	styleUrls: ['./validate-data.component.scss']
})
export class ValidateDataComponent implements OnInit {
	@ViewChild('myform') myform!: NgForm;
	@Input() titleform = '';
	@Input() securityQuestions: ISecQuestions[] = [];
	@Input() userData!: BeanUser;
	@Input() documentId!: number;
	naturalPerson = true;
	@Output() cancelRequest: EventEmitter<boolean> = new EventEmitter<boolean>(false);
	answersUser!: IrequestValidateAnswers;

	showSucces = false;
	sendEMail!: IRequestSendEmail;
	responseValidateQuestions!: IresponseValidateAnswers;
	errorMessageResponse = '';
	showError = false;
	errorMessage = '';
	showErrorMessage = false;

	constructor(
		private _configurationApiService: ConfigurationsApiService,
		private _sharedApiService: SharedApiService,
		private _pipeDate: DatePipe,
		private _alertService: AlertService
	) {}

	ngOnInit(): void {
		this.sendEMail = { template: 'userAccountGenClave', usercode: this.userData.personId.toString(), parameters: [] };
		this.errorMessage = 'Todas las preguntas deben ser respondidas';
	}

	validateData(): void {
		this.answersUser = {
			personId: this.userData.personId.toString(),
			usercode: this.userData.cip,
			parameters: []
		};
		this.securityQuestions.forEach((item) =>
			this.answersUser.parameters.push({ idPregunta: item.idquestion, respuesta: item.answer })
		);

		if (this.securityQuestions.length > 3) {
			const bornDate = this.answersUser.parameters[this.answersUser.parameters.length - 1].respuesta;
			this.answersUser.parameters[this.answersUser.parameters.length - 1].respuesta = this._pipeDate.transform(
				bornDate,
				'dd/MM/yyyy'
			)!;
		}
		this._configurationApiService.validateAnswersUser(this.answersUser).subscribe((res) => {
			this.responseValidateQuestions = res.data;
			if (res.status.code === '0000') {
				this.sendEMail.parameters.push(
					{
						name: 'nameUserAccount',
						value: res.data.datosnomResponse
					},
					{
						name: 'cipUserAccount',
						value: this.userData.cip
					},
					{
						name: 'claveUserAccount',
						value: res.data.passwordResponse
					}
				);

				this._sharedApiService.sendEmail(this.sendEMail).subscribe((responseEmail) => {
					this.showSucces = true;
				});
			} else {
				this.showError = true;
				// this.errorMessageResponse = res.status.message
				this.errorMessageResponse = 'Alguna de sus respuestas son incorrectas';
			}
		});
	}

	onClick(): void {
		if (this.myform.valid) {
			this.validateData();
		} else {
			this._alertService.showWarning(this.errorMessage);
		}
	}

	back(): void {
		this.cancelRequest.emit(true);
	}
}
